import { createStorageService } from './create-storage-service';

export const localStorageService = (key: string) =>
  createStorageService(key, window.localStorage);
